import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Utility } from 'src/app/core/common';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-focus-layout',
  templateUrl: './focus-layout.component.html',
  styleUrls: ['./focus-layout.component.scss']
})
export class FocusLayoutComponent implements OnInit {
  Utility = Utility;

  mode: string;
  logoLink = '/';

  constructor(
    public sharedService: SharedService,
    private _sanitizer: DomSanitizer) {
    sharedService.navigationEnd$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(() => {
        this.mode = sharedService.getRouteData('mode');
        this.logoLink = sharedService.getRouteData('logoLink') || this.logoLink;
      });
  }

  ngOnInit() {
  }

  private unsubscribe$ = new Subject<void>();
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  get resetTopStyles() {
    return this._sanitizer.bypassSecurityTrustHtml('<style>.sticky-top,.fixed-top {top: 0 !important;}</style>');
  }

  get logo() {
    if (this.mode == 'employer')
      return '/assets/images/logo/karpishe-employer.svg';
    return '/assets/images/KarpisheLogo.svg';
  }

  get logoTitle() {
    if (this.mode == 'employer')
      return 'کارفرمایان کارپیشه';

    return 'کارپیشه';
  }
}
